import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getMaintenanceFlagEntry } from "utils/maintenance";

export const useMaintenanceFlagEntry = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ["maintenance-bounty"], 
    queryFn: getMaintenanceFlagEntry,
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: 60000, // 1 minute
    refetchIntervalInBackground: true,
  });
};
